import React from "react";

import { Autocomplete, TextField } from "@mui/material";
import clsx from "clsx";
import { Field } from "formik";

import RequiredAsterisk from "./RequiredAsterisk";
import HelperIcon from "../helpers/HelperIcon";

import SelectFieldVirtualizedList from "./SelectFieldVirtualizedList";
import { createFilterOptions } from '@mui/material/Autocomplete';

const filter = createFilterOptions();

const SelectField = (props) => {
  const {
    label = "",
    name = "",
    options = [],
    formatClasses = [],
    required = false,
    helper = false,
    helperProperties = {},
    labelAdditions,
    disableLabel,
    placeholder,
    disabled = false,
    includeBlank = false,
    onChange,
    virtualized,
    fieldProperties,
    creatable = false
  } = props;
  const renderAutoComplete = ({ field, ...props }) => {
    const { options, form } = props;
    const foundOption = options.find((option) => option.value == field.value)
    const selectedOption = foundOption ? foundOption : (field.value ? {
      label: field.value,
      value: field.value,
    } : null);

    return (
      <>
        <Autocomplete
          {...props}
          disableClearable
          {...field}
          ListboxComponent={virtualized ? SelectFieldVirtualizedList : undefined}

          value={selectedOption}
          onChange={(e, newValue) => {
            newValue = newValue || { value: "" };

            form.setFieldValue(field.name, newValue.value);
            form.setFieldTouched(field.name, true);
            //field.onChange(e, newValue.value);
            if (onChange) {
              onChange(newValue.value);
            }
          }}
          clearOnBlur
          selectOnFocus
          filterOptions={(options, params) => {
            const filtered = filter(options, params);
            if(creatable) {
              const { inputValue } = params;
              // Suggest the creation of a new value
              const isExisting = options.some((option) => inputValue === option.title);
              if (inputValue !== '' && !isExisting) {
                filtered.push({
                  label: `Add "${inputValue}"`,
                  value: inputValue,
                });
              }
            }
         

            return filtered;
          }}
          renderInput={(params) => <TextField autoComplete="off" {...params} />}
        />
        <input type="hidden" name={field.name} value={field.value} />
      </>
    );
  };

  const getOptions = () => {
    let new_options = options;
    if (includeBlank) {
      new_options.unshift({ label: "", value: "" });
    }
    return new_options;
  };

  return (
    <div className={clsx("sg-mgmt-form-input-container", formatClasses)}>
      {disableLabel ? (
        ""
      ) : (
        <label>
          {label}
          {helper ? <HelperIcon {...(helperProperties || {})} /> : <></>}
          {labelAdditions ? labelAdditions : ""}
        </label>
      )}
      <Field
        component={renderAutoComplete}
        variant={"outlined"}
        options={getOptions()}
        size="small"
        fullWidth
        name={name}
        disabled={disabled}
        placeholder={placeholder}
        {...fieldProperties}
      />
    </div>
  );
};

export default SelectField;
